module.exports = __webpack_public_path__ + "assets/img/b4-bg1.30b08cd6.png";